import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import UpdatePrompt from './components/UpdatePrompt';
import RouteErrorBoundary from './components/RouteErrorBoundary';
import DevCrashTrigger from './components/DevCrashTrigger';

// Route-level code splitting: each screen ships as its own chunk so the
// initial load only pulls the landing/scan path. Heavy, rarely-hit screens
// (admin, schedule editor, badge sheets) no longer bloat first paint.
const Landing = lazy(() => import('./Landing'));
const SetupPage = lazy(() => import('./features/profile-setup/SetupPage'));
const ContactsPage = lazy(() => import('./features/contacts/ContactsPage'));
const EventItinerary = lazy(() => import('./EventItinerary'));
const AdminPage = lazy(() => import('./features/admin/AdminPage'));
const ProfileView = lazy(() => import('./ProfileView'));
const EventCreate = lazy(() => import('./EventCreate'));
const EventBadges = lazy(() => import('./EventBadges'));
const EventSchedule = lazy(() => import('./EventSchedule'));
const ProfileMine = lazy(() => import('./ProfileMine'));
const HowItWorks = lazy(() => import('./HowItWorks'));

// Matches the app's dark background so a chunk fetch doesn't flash white.
const RouteFallback = () => <div className="min-h-screen bg-[#0F1114]" />;

export default function App() {
  return (
    <BrowserRouter>
      <UpdatePrompt />
      <RouteErrorBoundary>
        <Suspense fallback={<RouteFallback />}>
          {import.meta.env.DEV && <DevCrashTrigger />}
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/setup" element={<SetupPage />} />
            <Route path="/profile" element={<ProfileMine />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/event/new" element={<EventCreate />} />
            <Route path="/event/:id/badges" element={<EventBadges />} />
            <Route path="/event/:id/schedule" element={<EventSchedule />} />
            <Route path="/event" element={<EventItinerary />} />
            <Route path="/event/:id" element={<EventItinerary />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/p/:code" element={<ProfileView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </RouteErrorBoundary>
    </BrowserRouter>
  );
}
